<template>

<div>
  <div
    style="width: 100%; height: 100%; text-align: center; padding-top: 100px"
    v-if="state.loaderEnabled"
  >
    <div class="lds-ring"><img src="media/logos/Logo-Symbole-couleur.svg"/><div></div><div></div><div></div><div></div></div>
  </div>

  <div class="card">
        <div class="card-header border-0 pt-6 pb-6">
          <button type="button" class="btn btn-sm btn-text-icon btn-primary btn-active-light m-1" style="margin-top: 9px !important; height: 44px;" @click="state.drawerImport = true">
            <span class="svg-icon svg-icon-1 svg-icon-dark">
              <inline-svg src="media/icons/duotune/files/fil022.svg" />
            </span>
            <span>
              {{$t("Interroger API Cisco")}}
            </span>
          </button>
            <SearchAndFilter
              :listInitial="state.initialMyList"
              :filters="[]"
              widthDecalage="200"
              @returnSearch="state.myList = $event"
              @returnLoadingDatatable="state.loadingDatatable = $event"
              ExcelFilename="Stillnetwork_Stock"
              :ExcelFormat="ExcelFormat"
            ></SearchAndFilter>
        </div>
      </div>  


      <transition name="fade">
   
        <el-container class="p-0">

          <el-main class="p-0">
            <div class="card mt-6" v-if="!state.loaderEnabled">
            <div class="card-body pt-0">

            <div
              v-if="state.myList.length == 0"
              class=" alert bg-light-primary alert-primary d-flex align-items-center p-5 mb-10 "
            >
              <span class="svg-icon svg-icon-2hx svg-icon-primary me-4">
                <inline-svg src="media/icons/duotune/general/gen048.svg" />
              </span>
              <div class="d-flex flex-column">
                <h4 class="mb-1 text-dark">{{$t("Aucun Contrat")}}</h4>
                <span
                  >{{$t("Il n'existe aucun contrat à afficher correspondant à vos critères de recherche.")}}</span
                >
              </div>
            </div>
            <Datatable
              v-if="state.myList && state.myList.length > 0"
              :table-data="state.myList"
              :table-header="tableHeader"
              :enable-items-per-page-dropdown="true"
              empty-table-text="Aucun contrat à afficher."
              :key="state.loadingDatatable"
            >
              <template v-slot:cell-smartAccount="{ row: data }">
                <div class="" >
                  <span class="fs-7 text-dark"><b>{{ data.smartAccount }}</b></span><br>
                  <span class="fs-6 text-muted">{{ data.virtualAccount }}</span>
                </div>
              </template>

              <template v-slot:cell-type="{ row: data }">
                <div class="badge badge-light-primary" >
                  {{ data.type }}
                </div>
              </template>

              <template v-slot:cell-licences="{ row: data }">
                <div class="" >
                  {{ data.licences }}
                </div>
              </template>

              <template v-slot:cell-Qty="{ row: data }">
                <div class="w-100px text-dark fs-4 " style="text-align: left" >
                  <span class="fs-4 ms-3 fw-bolder">{{ data.Qty }}</span><br>
                  <div v-if="data.addQty" class="badge badge-light-warning"><span class="fs-7 text-gray-700">{{ data.addQty }} en + </span></div>
                </div>
              </template>

              <template v-slot:cell-code="">
                <a class="btn btn-sm btn-active-primary me-2 mb-2 btn-bg-white btn-text-dark" >
                  <span class="svg-icon svg-icon-1 svg-icon-primary">
                    <inline-svg src="media/icons/duotune/general/gen004.svg"/> </span>
                    {{$t("Historique des quantités")}}
                </a>
              </template>
            </Datatable>

            </div>
          </div>
          </el-main>

          <el-aside width="360px" style="overflow: hidden;">
            <div class="card mt-6 ms-4" v-if="!state.loaderEnabled && state.myList">
            <div class="card-body pt-0">

            <el-tabs class="tabsPresta pt-9 mb-5">
              <el-tab-pane disabled :label="$t('Synthèse et filtres')" ></el-tab-pane>
            </el-tabs>

            <div class="card-title">
              <h4 class="fw-bolder mb-0 mt-6">{{$t("Comparer la liste :")}}</h4>
            </div>

            <div class="mt-6">Depuis le</div><input class="form form-control w-200px" type="date" value="2023-04-01">

            <div class="card-title mt-10">
              <h4 class="fw-bolder mb-0 mt-6">{{$t("Sous totaux :")}}</h4>
            </div>

            <div>
              <b>Quantité totale à ce jour de </b><span class="fs-4 text-primary fw-bolder ms-2">{{ total() }}</span>
            </div>
            <div>
              <b>Quantité totale au 01/04/2023 de </b><span class="fs-4 text-primary fw-bolder ms-2">{{ total() - totalAdd() }}</span>
            </div>

            <div>
              <b>Soit un ajout de </b><span class="fs-4 text-primary fw-bolder ms-2">{{ totalAdd() }}</span>
            </div>

            <div class="card-title mt-10">
              <h4 class="fw-bolder mb-0 mt-6">{{$t("Filtrer la liste :")}}</h4>
            </div>

            <div class="card-header border-0 p-0">
              <SearchAndFilter
                :listInitial="state.initialMyList"
                :filters="tableFilters"
                @returnSearch="state.myList = $event"
                @returnLoadingDatatable="state.loadingDatatable = $event"
                widthDecalage="0"
                :searchBar = 0
                classSearch = "d-none"
                classGroupSelect="align-items-center"
                classSelect="mx-0 w-275px text-primary me-3 m-2 mt-2"
              ></SearchAndFilter>
            </div>
            </div>
          </div>
          </el-aside>

        </el-container>   


  </transition>

  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, reactive } from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import { MenuComponent } from "@/assets/ts/components";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import * as moment from "moment";
import SearchAndFilter from "@/views/still/search_and_filters.vue";

export default defineComponent({
  name: "Liste des commandes en cours",
  components: {
    Datatable,
    SearchAndFilter,
  },

  emits: ["refreshRouter"],

  setup(props, { emit }) {
    //moment.default.locale("fr");
    const state = reactive({
      loaderEnabled: true,
      myList: [] as any,
      drawer: ref(false),
      drawerImport: ref(false),
      sourcePDF: "",
      mFact: "",
      initialMyList: [] as any,
      loadingDatatable: 0,
      search: "",
      contratSelect: {},
    });

    const tableHeader = ref([
      {
        name: "smart Account",
        key: "smartAccount",
        sortable: true,
      },
      {
        name: "Type",
        key: "type",
        sortable: true,
      },
      {
        name: "Licences",
        key: "licences",
        sortable: true,
      },
      {
        name: "Quantité",
        key: "Qty",
        sortable: true,
      },
      {
        name: "Actions",
        key: "code",
        sortable: true,
      },
    ]);

    const tableFilters = ref([
      {
        name: "Smart Account",
        key: "smartAccount",
        label: "smartAccount",
      },
      {
        name: "Virtual Account",
        key: "virtualAccount",
        label: "virtualAccount",
      },
      {
        name: "type",
        key: "type",
        label: "type",
      },
    ]);

    const ExcelFormat = ref({
      "Contrat": "fsh_contract_number",
      type: "loc_nature",  
      "Libellé du contrat": "cont_libelle",
      "Début": "fsh_date_debut",
      "Fin": "fsh_date_fin",
      "Commandes": "xlienssmart",
    });

    const formatDate = (d) => {
      return moment.default(d).format("DD.MM.YYYY");
    };

    const test_3_month = (d) => {
      const currentDate = moment.default().add(3, 'M');
      return moment.default(d) > currentDate;
    }

    const total = () => {
      let total = 0 as any;
      state.myList.forEach(element => {
        total = parseInt(total) + parseInt(element.Qty)
      });
      return total;
    }


    const totalAdd = () => {
      let total = 0 as any;
      state.myList.forEach(element => {
        total = parseInt(total) + parseInt(element.addQty)
      });
      return total;
    }
   

    onMounted(async () => {
      MenuComponent.reinitialization();
      setCurrentPageBreadcrumbs("Gestion des Contrats de support & Licences", []);

      let myList = [{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"Aironet DNA Advantage Term Licenses","Qty":"474","type":"Cisco DNA Wireless","addQty":8},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"Aironet DNA Essentials Term Licenses","Qty":"349","type":"Cisco DNA Wireless","addQty":2},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9200 DNA Advantage | 24-port Term licenses","Qty":"2","type":"Cisco DNA Switching","addQty":"2"},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9200 DNA Advantage | 48-port Term licenses","Qty":"25","type":"Cisco DNA Switching","addQty":15},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9200 DNA Essentials | 24-port Term licenses","Qty":"44","type":"Cisco DNA Switching","addQty":6},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9200 DNA Essentials | 48-port Term licenses","Qty":"274","type":"Cisco DNA Switching","addQty":12},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9200CX DNA Essentials - 12 Ports","Qty":"16","type":"Cisco DNA Switching","addQty":"16"},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9200CX DNA Essentials - 8 Ports","Qty":"2","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9200L DNA Advantage | 24-port Term license","Qty":"3","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9200L DNA Essentials | 24-port Term license","Qty":"53","type":"Cisco DNA Switching","addQty":18},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9200L DNA Essentials | 48-port Term license","Qty":"84","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9300 24P DNA Advantage","Qty":"54","type":"Cisco DNA Switching","addQty":5},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9300 24P DNA Essentials","Qty":"21","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9300 48P DNA Advantage","Qty":"42","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9300 48P DNA Essentials","Qty":"5","type":"Cisco DNA Switching","addQty":"5"},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9300L 24P DNA Advantage","Qty":"4","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9300L 48P DNA Essentials","Qty":"11","type":"Cisco DNA Switching","addQty":7},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9500-DNA-40X-A","Qty":"5","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9500-DNA-40X-E","Qty":"14","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"IE2000 DNA Essentials (12 ports)","Qty":"40","type":"Cisco DNA Switching","addQty":1},{"smartAccount":"Testinium.com","virtualAccount":"TEST_Indonisia_Jakarta","licences":"Aironet DNA Advantage Term Licenses","Qty":"4","type":"Cisco DNA Wireless","addQty":"4"},{"smartAccount":"Testinium.com","virtualAccount":"TEST_Indonisia_Jakarta","licences":"C9200 DNA Essentials | 24-port Term licenses","Qty":"2","type":"Cisco DNA Switching","addQty":"2"},{"smartAccount":"Testinium.com","virtualAccount":"TEST_Indonisia_Jakarta","licences":"C9300 24P DNA Advantage","Qty":"2","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TEST_Russia_Togliatti","licences":"C9300 24P DNA Advantage","Qty":"2","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TEST_Spain_Vigo","licences":"C9300 24P DNA Advantage","Qty":"2","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TEST_Thailand_Rayong","licences":"C9200 DNA Essentials | 48-port Term licenses","Qty":"2","type":"Cisco DNA Switching","addQty":"2"},{"smartAccount":"Testinium.com","virtualAccount":"TEST_USA_Troy Bellingham","licences":"C9300 24P DNA Advantage","Qty":"2","type":"Cisco DNA Switching","addQty":"2"},{"smartAccount":"Testinium.com","virtualAccount":"TEST_USA_Troy Bellingham","licences":"C9300 24P DNA Essentials","Qty":"3","type":"Cisco DNA Switching","addQty":"3"},{"smartAccount":"Testinium.com","virtualAccount":"TESTRP_France_Nanterre","licences":"Aironet DNA Advantage Term Licenses","Qty":"1","type":"Cisco DNA Wireless","addQty":"1"},{"smartAccount":"Testinium.com","virtualAccount":"TESTRP_France_Nanterre","licences":"C2960X-24P DNA Essentials","Qty":"2","type":"Cisco DNA Switching","addQty":"2"},{"smartAccount":"Testinium.com","virtualAccount":"TESTRP_France_Nanterre","licences":"C9200 DNA Essentials | 24-port Term licenses","Qty":"2","type":"Cisco DNA Switching","addQty":"2"},{"smartAccount":"Testinium.com","virtualAccount":"TESTRP_France_Nanterre","licences":"C9300 24P DNA Advantage","Qty":"2","type":"Cisco DNA Switching","addQty":"2"},{"smartAccount":"Testinium.com","virtualAccount":"TESTRP_France_Nanterre","licences":"DNAC Gen2 Appliance - Large( 56 Core)","Qty":"1","type":"Cisco DNA Switching","addQty":"1"},{"smartAccount":"Testinium.com","virtualAccount":"TESTRP_France_Nanterre","licences":"IE2000 DNA Essentials (12 ports)","Qty":"1","type":"Cisco DNA Switching","addQty":"1"},{"smartAccount":"Testinium.com","virtualAccount":"TESTOG_France_Levallois","licences":"Aironet DNA Advantage Term Licenses","Qty":"54","type":"Cisco DNA Wireless","addQty":2},{"smartAccount":"Testinium.com","virtualAccount":"TESTOG_France_Levallois","licences":"Aironet DNA Essentials Term Licenses","Qty":"5","type":"Cisco DNA Wireless","addQty":"5"},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_France_Flers","licences":"Aironet DNA Advantage Term Licenses","Qty":"8","type":"Cisco DNA Wireless","addQty":"8"},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_France_Fontaine","licences":"C9200 DNA Essentials | 48-port Term licenses","Qty":"11","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_France_Fontaine","licences":"C9300 24P DNA Advantage","Qty":"3","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_France_Guichen","licences":"Aironet DNA Advantage Term Licenses","Qty":"21","type":"Cisco DNA Wireless","addQty":18},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_France_Guichen","licences":"C9200 DNA Essentials | 24-port Term licenses","Qty":"21","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_France_Ruitz","licences":"Aironet DNA Advantage Term Licenses","Qty":"8","type":"Cisco DNA Wireless","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Slovakia_Hlohovec","licences":"C9200 DNA Essentials | 24-port Term licenses","Qty":"3","type":"Cisco DNA Switching","addQty":"3"},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Arevalo","licences":"C9200 DNA Essentials | 24-port Term licenses","Qty":"1","type":"Cisco DNA Switching","addQty":"1"},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Arevalo","licences":"C9200 DNA Essentials | 48-port Term licenses","Qty":"1","type":"Cisco DNA Switching","addQty":"1"},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Arevalo","licences":"C9500-DNA-40X-A","Qty":"2","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9200 DNA Essentials | 24-port Term licenses","Qty":"5","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9200 DNA Essentials | 48-port Term licenses","Qty":"7","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9200L DNA Essentials | 48-port Term license","Qty":"1","type":"Cisco DNA Switching","addQty":"1"},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9300 24P DNA Advantage","Qty":"3","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Redondela","licences":"C9300 24P DNA Advantage","Qty":"3","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Valencia","licences":"C9200 DNA Essentials | 24-port Term licenses","Qty":"6","type":"Cisco DNA Switching","addQty":"6"},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_Spain_Valencia","licences":"C9200 DNA Essentials | 48-port Term licenses","Qty":"18","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_USA_Anderson","licences":"Aironet DNA Essentials Term Licenses","Qty":"15","type":"Cisco DNA Wireless","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_United_Kingdom_Measham","licences":"C9400 DNA Advantage","Qty":"2","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_United_Kingdom_Measham","licences":"DNAC Gen2 Appliance - Regular (44 Core)","Qty":"1","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_United_Kingdom_Ventura","licences":"C9200 DNA Advantage | 48-port Term licenses","Qty":"0","type":"Cisco DNA Switching","addQty":"0"},{"smartAccount":"Testinium.com","virtualAccount":"TESTIES_United_Kingdom_Ventura","licences":"C9200 DNA Essentials | 24-port Term licenses","Qty":"0","type":"Cisco DNA Switching","addQty":"0"},{"smartAccount":"Testinium.com","virtualAccount":"PONE","licences":"Aironet DNA Advantage Term Licenses","Qty":"16","type":"Cisco DNA Wireless","addQty":8},{"smartAccount":"Testinium.com","virtualAccount":"PONE","licences":"C9200 DNA Essentials | 48-port Term licenses","Qty":"3","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"PONE","licences":"C9300 48P DNA Advantage","Qty":"4","type":"Cisco DNA Switching","addQty":2},{"smartAccount":"Testinium.com","virtualAccount":"PONE-BE-GEN (OnPrem)","licences":"Aironet DNA Essentials Term Licenses","Qty":"17","type":"Cisco DNA Wireless","addQty":0},{"smartAccount":"Testinium.com","virtualAccount":"PONE-BE-GEN (OnPrem)","licences":"C9300 48P DNA Advantage","Qty":"2","type":"Cisco DNA Switching","addQty":2},{"smartAccount":"Testinium.com","virtualAccount":"PONE-BE-GEN (OnPrem)","licences":"C9300 48P DNA Essentials","Qty":"0","type":"Cisco DNA Switching","addQty":"0"},{"smartAccount":"sigmatech.Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"Aironet DNA Advantage Term Licenses","Qty":"19","type":"Cisco DNA Wireless","addQty":19},{"smartAccount":"sigmatech.Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9200 DNA Essentials | 24-port Term licenses","Qty":"7","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"sigmatech.Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9200 DNA Essentials | 48-port Term licenses","Qty":"45","type":"Cisco DNA Switching","addQty":11},{"smartAccount":"sigmatech.Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9300 24P DNA Advantage","Qty":"2","type":"Cisco DNA Switching","addQty":1},{"smartAccount":"sigmatech.Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9300 24P DNA Essentials","Qty":"2","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"sigmatech.Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9300 48P DNA Advantage","Qty":"3","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"in.Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"Aironet DNA Essentials Term Licenses","Qty":"2","type":"Cisco DNA Wireless","addQty":"2"},{"smartAccount":"in.Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9300 24P DNA Advantage","Qty":"2","type":"Cisco DNA Switching","addQty":"2"},{"smartAccount":"in.Testinium.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9300 48P DNA Advantage","Qty":"2","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"testiclighting.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"Aironet DNA Essentials Term Licenses","Qty":"12","type":"Cisco DNA Wireless","addQty":3},{"smartAccount":"testiclighting.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9200L DNA Essentials | 48-port Term license","Qty":"1","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"testiclighting.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9300 24P DNA Advantage","Qty":"2","type":"Cisco DNA Switching","addQty":"2"},{"smartAccount":"testiclighting.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9300 24P DNA Essentials","Qty":"2","type":"Cisco DNA Switching","addQty":"2"},{"smartAccount":"testiclighting.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9300 48P DNA Advantage","Qty":"19","type":"Cisco DNA Switching","addQty":0},{"smartAccount":"testiclighting.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9300 48P DNA Essentials","Qty":"2","type":"Cisco DNA Switching","addQty":"2"},{"smartAccount":"testiclighting.com","virtualAccount":"TESTIES_Spain_Barcelona","licences":"C9500-DNA-16X-A","Qty":"4","type":"Cisco DNA Switching","addQty":"4"}]

      state.initialMyList = myList;
      state.myList = myList;      

      
      (myList as any).forEach((element) => {
        let tot = -10 + random();
        if (tot < 0) tot = 0;
        if (tot > element.Qty) tot = element.Qty
        element.addQty = tot;
      });

      console.log("A",JSON.stringify(myList));

      

      state.loaderEnabled = false;
    });

    const random = () => {
      return Math.floor(Math.random() * 30);
    }

    return {
      tableHeader,
      state,
      formatDate,
      test_3_month,
      tableFilters,
      ExcelFormat,
      random,
      total,
      totalAdd
    };
  },
});
</script>

<style>
.el-dropdown-menu_item:hover {
  cursor: pointer;
  background-color: #e4e7ed !important;
}
</style>